<div class="row">
  <div class="container">
    <div style="position: relative;">
      <div *ngIf="versiones.length > 0" class="version-dropdown-wrapper">
        <select class="version-select" [ngModel]="selectedVersion" [compareWith]="compareVersiones"
          (ngModelChange)="onVersionChange($event)">
          <option *ngFor="let v of versiones" [ngValue]="v">VERSIÓN {{v.numeroVersion}}</option>
        </select>
      </div>
      <div *ngIf="isEditMode && !esVersionMasReciente" class="alert alert-warning mb-2" role="alert">
        <strong>Estás viendo una versión histórica.</strong>
        Seleccioná la última versión para poder guardar o enviar.
      </div>
      <mat-tab-group (selectedTabChange)="tabOption($event, '')" [selectedIndex]="selectedIndex">
        <mat-tab label="INICIO">
          <form [formGroup]="formInit">
            <div class="row p-0 m-0 mt-5">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                <div id="groupTipoSolicitud" class="mt-2">
                  <p>Selecciona el <strong>Tipo de Solicitud</strong></p>
                  <div id="radioInputTipoSolicitud" class="group-radio"
                    [style.pointer-events]="(isEditMode && !esVersionMasReciente) ? 'none' : 'auto'"
                    [style.opacity]="(isEditMode && !esVersionMasReciente) ? '0.5' : '1'">
                    <input class="radio-input" type="radio" value="1" name="tipoSolicitud" id="rb1"
                      formControlName="tipoSolicitud" (change)="validateTipoSolicitud()"
                      [attr.disabled]="(isEditMode && esNuevoColectivo) ? '' : null" />
                    <label class="label-radio" for="rb1"
                      [style.opacity]="(isEditMode && esNuevoColectivo) ? '0.5' : '1'"
                      [style.cursor]="(isEditMode && esNuevoColectivo) ? 'not-allowed' : 'pointer'">VENTA NUEVA</label>
                    <input class="radio-input" type="radio" value="2" name="tipoSolicitud" id="rb2"
                      formControlName="tipoSolicitud" (change)="validateTipoSolicitud()"
                      [attr.disabled]="(isEditMode && esNuevoColectivo) ? '' : null" />
                    <label class="label-radio" for="rb2"
                      [style.opacity]="(isEditMode && esNuevoColectivo) ? '0.5' : '1'"
                      [style.cursor]="(isEditMode && esNuevoColectivo) ? 'not-allowed' : 'pointer'">INCLUSIÓN</label>
                    <!-- Nuevo colectivo queda oculto en el inicio. No se borra.
                    <input class="radio-input" type="radio" value="3" name="tipoSolicitud" id="rb3"
                      formControlName="tipoSolicitud" (change)="validateTipoSolicitud()" />
                    <label class="label-radio" for="rb3">NUEVO COLECTIVO</label>
                    -->
                  </div>
                </div>
                <div id="groupTipoPlan" class="mt-2"
                  *ngIf="formInit.get('tipoSolicitud')?.value && formInit.get('tipoSolicitud')?.value != 3">
                  <p>Selecciona el <strong>Tipo de plan</strong></p>
                  <div id="radioInputTipoPlan" class="group-radio"
                    [style.pointer-events]="(isEditMode && !esVersionMasReciente) ? 'none' : 'auto'"
                    [style.opacity]="(isEditMode && !esVersionMasReciente) ? '0.5' : '1'">
                    <input class="radio-input" type="radio" name="tipoPlan" formControlName="tipoPlan" value="F"
                      id="rTipoplanF" (change)="selectPrograms()" />
                    <label [style]="blockedTipoPlanQuestion?'cursor: no-drop;':''" id="lblrTipoplanF"
                      class="label-radio" for="rTipoplanF">FAMILIAR</label>
                    <input class="radio-input" type="radio" name="tipoPlan" formControlName="tipoPlan" value="A"
                      id="rTipoplanA" (change)="selectPrograms()" />
                    <label [style]="blockedTipoPlanQuestion?'cursor: no-drop;':''" id="lblrTipoplanA"
                      class="label-radio" for="rTipoplanA">ASOCIADO</label>
                    <input class="radio-input" type="radio" name="tipoPlan" formControlName="tipoPlan" value="E"
                      id="rTipoplanE" (change)="selectPrograms()" />
                    <label [style]="blockedTipoPlanQuestion?'cursor: no-drop;':''" id="lblrTipoplanE"
                      class="label-radio" for="rTipoplanE">EMPLEADO</label>
                    <input class="radio-input" type="radio" name="tipoPlan" formControlName="tipoPlan" value="C"
                      id="rTipoplanC" *ngIf="
                        formInit.get('tipoSolicitud')?.value === '1' ||
                        formInit.get('tipoSolicitud')?.value === '2'
                      " (change)="selectPrograms()" />
                    <label [style]="blockedTipoPlanQuestion?'cursor: no-drop;':''" id="lblrTipoplanC"
                      class="label-radio" for="rTipoplanC" *ngIf="
                        formInit.get('tipoSolicitud')?.value === '1' ||
                        formInit.get('tipoSolicitud')?.value === '2'
                      ">COLECTIVO</label>
                    <input class="radio-input" type="radio" name="tipoPlan" formControlName="tipoPlan" value="GA"
                      id="rTipoplanGA" (change)="selectPrograms()" />
                    <label [style]="blockedTipoPlanQuestion?'cursor: no-drop;':''" id="lblrTipoplanGA"
                      class="label-radio" for="rTipoplanGA">GRUPOS DE AFINIDAD</label>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </mat-tab>
        <mat-tab *ngIf="tabHabilitado.contratante && !esNuevoColectivo" label="CONTRATANTE">
          <app-formulario-contratante [tipoSolicitud]="formInit.get('tipoSolicitud')?.value || ''"
            [tipoPlan]="formInit.get('tipoPlan')?.value || ''" [soloLectura]="isEditMode && !esVersionMasReciente">
          </app-formulario-contratante>
        </mat-tab>
        <mat-tab *ngIf="tabHabilitado.colectivo" label="COLECTIVO">
          <form style="margin-bottom: 20px !important;" [formGroup]="formColectivo"
            [style.pointer-events]="(isEditMode && !esVersionMasReciente) ? 'none' : 'auto'"
            [style.opacity]="(isEditMode && !esVersionMasReciente) ? '0.5' : '1'">
            <div class="row p-0 m-0 mb-3" *ngIf="mostrarAlertaCamposColectivo">
              <div class="col-12">
                <div class="alert alert-danger mb-0" role="alert">
                  Por favor, verifique los campos obligatorios marcados en rojo antes de continuar.
                </div>
              </div>
            </div>
            <div class="row p-0 m-0 mt-5">
              <div class="col-xs-12 col-md-4 col-lg-4">
                <mat-label>Fecha de presentación de la cotización *</mat-label>

                <mat-form-field appearance="outline">
                  <input matInput [matDatepicker]="pickerPresentacion" formControlName="fechaPresentacion"
                    placeholder="DD/MM/AAAA" required>

                  <mat-datepicker-toggle matSuffix [for]="pickerPresentacion"></mat-datepicker-toggle>
                  <mat-datepicker #pickerPresentacion></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-md-4 col-lg-4">
                <mat-label>Fecha de inicio vigencia *</mat-label>

                <mat-form-field appearance="outline">
                  <input matInput [matDatepicker]="pickerVigencia" formControlName="fechaInicioVigencia"
                    placeholder="DD/MM/AAAA" required>

                  <mat-datepicker-toggle matSuffix [for]="pickerVigencia"></mat-datepicker-toggle>
                  <mat-datepicker #pickerVigencia></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-md-4 col-lg-4">
                <mat-label>Regional *</mat-label>
                <mat-form-field class="" color="primary" appearance="outline">
                  <mat-select formControlName="regional" required>
                    <mat-option>Seleccionar</mat-option>
                    <mat-option *ngFor="let item of regional" [value]="item.Codigo_regional">
                      {{item.Nombre_regional}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row p-0 m-0">
              <div class="col-xs-12 col-md-4 col-lg-4">
                <mat-label>Oficina *</mat-label>
                <mat-form-field class="" color="primary" appearance="outline">
                  <mat-select formControlName="oficina" required>
                    <mat-option>Seleccionar</mat-option>
                    <mat-option *ngFor="let sucursal of sucursalesRegional" [value]="sucursal.cod_sucursal">
                      {{sucursal.nombre_sucursal}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-md-4 col-lg-4">
                <mat-label>Canal *</mat-label>
                <mat-form-field class="" color="primary" appearance="outline">
                  <mat-select formControlName="canal" required>
                    <mat-option *ngFor="let item of canal" [value]="item.value">
                      {{item.label}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-md-4 col-lg-4">
                <mat-label>Tipo de asesor *</mat-label>
                <mat-form-field class="" color="primary" appearance="outline">
                  <mat-select formControlName="tipoAsesor" required>
                    <mat-option>Seleccionar</mat-option>
                    <mat-option *ngFor="let item of tiposFiltrados" [value]="item.tipo">
                      {{item.nombreMostrar }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row p-0 m-0">
              <div class="col-xs-12 col-md-4 col-lg-4">
                <h3 class="section-heading"><strong>DATOS DE LA EMPRESA</strong></h3>
              </div>
            </div>
            <div class="row p-0 m-0">
              <div class="col-xs-12 col-md-4 col-lg-4">
                <mat-label>NIT *</mat-label>

                <mat-form-field appearance="outline">
                  <input
                    matInput
                    type="text"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    (keypress)="permitirSoloNumeros($event)"
                    (paste)="validarPegadoSoloNumeros($event)"
                    (keyup.enter)="buscarEmpresa()"
                    formControlName="nit"
                    maxlength="10"
                    #message
                    matTooltip="Ingrese únicamente el número de NIT sin dígito de verificación, puntos ni comas."
                    matTooltipPosition="above"
                  >

                  <mat-icon (click)="buscarEmpresa()" matSuffix>search</mat-icon>

                  <mat-hint align="start"><strong></strong></mat-hint>

                  <mat-hint align="end">
                    <label>{{ message.value.length }}</label> / 10
                  </mat-hint>

                  <mat-error *ngIf="fieldsValidators('nit')">
                    <label>{{ errorsMsg('nit') }}</label>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-md-7 col-lg-7">
                <mat-label>Nombre *</mat-label>
                <mat-form-field class="example-full-width" appearance="outline">
                  <input formControlName="colectivoNombre" matInput minlength="3" maxlength="40"
                  (input)="normalizarTextoContacto('colectivoNombre')">
                  <mat-error *ngIf="fieldsValidators('colectivoNombre')">
                    <label>
                      {{errorsMsg('colectivoNombre')}}
                    </label>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row p-0 m-0">
              <div class="col-xs-12 col-md-4 col-lg-4">
                <mat-label>Sector</mat-label>
                <mat-form-field class="" color="primary" appearance="outline">
                  <mat-select formControlName="sector">
                    <mat-option>
                      <ngx-mat-select-search [formControl]="sectorFiltro" placeholderLabel="Buscar sector..."
                        noEntriesFoundLabel="No encontrado">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option>Seleccionar</mat-option>
                    <mat-option *ngFor="let item of sectoresFiltrados" [value]="item.idSector">
                      {{ item.nombreSector }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-md-4 col-lg-4">
                <mat-label>Departamento</mat-label>
                <mat-form-field class="" color="primary" appearance="outline">
                  <mat-select formControlName="departamento" required>
                    <mat-option>Seleccionar</mat-option>
                    <mat-option *ngFor="let d of departamentos" [value]="d.codigo">
                      {{d.nombre }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-md-4 col-lg-4">
                <mat-label>Municipio</mat-label>
                <mat-form-field class="" color="primary" appearance="outline">
                  <mat-select formControlName="municipio" [disabled]="municipios.length === 0" required>
                    <mat-option>Seleccionar</mat-option>
                    <mat-option *ngFor="let m of municipios" [value]="m.codigo">
                      {{m.municipio }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row p-0 m-0 align-items-center">
              <div class="col-12 col-md-auto">
                <mat-label>¿Cliente actual CMP?</mat-label>
              </div>
              <div class="col-12 col-md-auto">
                <div [style.border]="fieldsValidators('clienteActual') ? '1px solid #dc3545' : '1px solid transparent'"
                  [style.borderRadius.px]="4" [style.padding.px]="4">
                  <mat-radio-group (change)="enableCampanias()" class="radio-group radio-group-inline"
                    formControlName="clienteActual" color="primary">
                    <mat-radio-button class="inline-radio" value="1">SI</mat-radio-button>
                    <mat-radio-button class="inline-radio" value="2">NO</mat-radio-button>
                  </mat-radio-group>
                </div>
                <div class="text-danger mt-1" *ngIf="fieldsValidators('clienteActual')">
                  {{ errorsMsg('clienteActual') }}
                </div>
              </div>
            </div>
            <div class="row p-0 m-0">
              <div class="col-xs-12 col-md-3 col-lg-3">
                <mat-label>Usuarios a cotizar *</mat-label>
                <mat-form-field class="example-full-width" appearance="outline">
                  <input type="text" maxlength="6" inputmode="numeric" matInput formControlName="usuariosCotizar"
                    (keypress)="permitirSoloNumeros($event)" (paste)="validarPegadoSoloNumeros($event)" required>
                  <mat-hint></mat-hint>
                  <mat-error *ngIf="fieldsValidators('usuariosCotizar')">
                    <label>
                      {{errorsMsg('usuariosCotizar')}}
                    </label>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-md-3 col-lg-3">
                <mat-label>Usuarios > 60 años *</mat-label>
                <mat-form-field class="example-full-width" appearance="outline">
                  <input type="text" maxlength="6" inputmode="numeric" matInput formControlName="usuariosMayor60"
                    (keypress)="permitirSoloNumeros($event)" (paste)="validarPegadoSoloNumeros($event)" required>
                  <mat-hint></mat-hint>
                  <mat-error *ngIf="fieldsValidators('usuariosMayor60')">
                    <label>
                      {{errorsMsg('usuariosMayor60')}}
                    </label>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-md-3 col-lg-3">
                <mat-label>% Usuarios > 60 años *</mat-label>
                <mat-form-field class="example-full-width" appearance="outline">
                  <input type="text" matInput formControlName="UsuariosMayor60Total" readonly>
                  <mat-hint></mat-hint>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-md-3 col-lg-3">
                <mat-label>Embarazos en curso</mat-label>
                <mat-form-field class="example-full-width" appearance="outline">
                  <input type="text" maxlength="6" inputmode="numeric" matInput formControlName="embarazosCurso"
                    (keypress)="permitirSoloNumeros($event)"
                    (paste)="validarPegadoSoloNumeros($event)">
                  <mat-error *ngIf="fieldsValidators('embarazosCurso')">
                    <label>
                      {{errorsMsg('embarazosCurso')}}
                    </label>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row p-0 m-0">
              <h3><strong>PRODUCTOS A COTIZAR</strong></h3>
              <div id="groupLineaNegocio" class="mt-2">
                <p>Selecciona la(s) <strong>Línea(s) de Negocio</strong></p>

                <div id="radioInputLineaNegocio" class="group-radio">

                  <input type="checkbox" id="linea1" class="radio-input" value="1"
                    [checked]="lineasNegocio.value.includes('1')" (change)="onLineaNegocioChange($event)"
                    [disabled]="lineasNegocioBloqueadas.has('1')">
                  <label class="label-radio" for="linea1">MEDICINA INTEGRAL</label>

                  <input type="checkbox" id="linea2" class="radio-input" value="2"
                    [checked]="lineasNegocio.value.includes('2')" (change)="onLineaNegocioChange($event)"
                    [disabled]="lineasNegocioBloqueadas.has('2')">
                  <label class="label-radio" for="linea2">SALUD ORAL</label>

                  <input type="checkbox" id="linea3" class="radio-input" value="3"
                    [checked]="lineasNegocio.value.includes('3')" (change)="onLineaNegocioChange($event)"
                    [disabled]="lineasNegocioBloqueadas.has('3')">
                  <label class="label-radio" for="linea3">CEM</label>

                </div>
              </div>
              <div id="groupProgramas" class="mt-2">

              </div>
              <div *ngIf="lineasNegocioSeleccionadas.length && hayProgramasSeleccionados" class="row programas-section">
                <div class="col-12">
                  <p>Selecciona los <strong>Programas</strong></p>
                </div>
                <div class="col-12">
                  <div class="programas-grid">
                    <div class="programas-columna" *ngFor="let linea of lineasNegocioSeleccionadas">
                      <h4>{{ displayNameForLinea(linea) }}</h4>

                      <div class="programas-grid-inner">
                        <div class="programa-card" *ngFor="let programa of programasCarnetPorLinea[linea] || []"
                          [class.programa-card-selected]="esProgramaSeleccionado(programa.code || programa.program)"
                          (click)="toggleProgramaSeleccion(programa.code || programa.program)">
                          <div class="check-icon" *ngIf="esProgramaSeleccionado(programa.code || programa.program)">
                            ✔
                          </div>
                          <img [src]="programa.file" [alt]="programa.program">
                          <span>{{ programa.program }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12" *ngIf="mostrarSeccionAnexos">
                  <div class="anexos-section">
                    <div class="anexos-checkboxes">
                      <div class="anexo-programa-bloque" *ngFor="let programa of programasConAnexosDisponibles">
                        <div class="anexo-fila">
                          <span class="anexo-checkbox-label">Incluir anexos</span>
                          <mat-radio-group
                            class="anexo-programa-radios"
                            [ngModel]="isProgramaAnexoSelected(programa.code) ? 'si' : 'no'"
                            [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="setProgramaAnexoSelection(programa.code, $event)">
                            <mat-radio-button value="si" class="anexos-radio">SI</mat-radio-button>
                            <mat-radio-button value="no" class="anexos-radio">NO</mat-radio-button>
                          </mat-radio-group>
                          <span class="anexo-programa-titulo">{{ programa.program }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-auto d-flex align-items-center">
                <mat-label>¿Derecho a subsidio?</mat-label>
              </div>
              <div class="col-12 col-md-auto">
                <div
                  [style.border]="fieldsValidators('derechoAsubsidio') ? '1px solid #dc3545' : '1px solid transparent'"
                  [style.borderRadius.px]="4" [style.padding.px]="4">
                  <mat-radio-group class="radio-group radio-group-inline" formControlName="derechoAsubsidio"
                    color="primary">
                    <mat-radio-button style=" margin-left:10px" value="1">SI</mat-radio-button>
                    <mat-radio-button style=" margin-left:10px" value="2">NO</mat-radio-button>
                  </mat-radio-group>
                </div>
                <div class="text-danger mt-1" *ngIf="fieldsValidators('derechoAsubsidio')">
                  {{ errorsMsg('derechoAsubsidio') }}
                </div>
              </div>
            </div>
            <div class="row p-0 m-0 mt-3 align-items-center"
              *ngIf="formColectivo.get('derechoAsubsidio')?.value === '1'">
              <!-- Columna 1 -->
              <div class="col-12 col-md-4">
                <mat-label>
                  Selecciona el <strong>porcentaje de subsidio</strong>
                </mat-label>
              </div>
              <!-- Columna 2 -->
              <div class="col-12 col-md-4">
                <div id="radioInputPorcentaje" class="group-radio">
                  <input class="radio-input" type="radio" value="1" id="porcentaje1" name="porcentajeSubsidio"
                    formControlName="porcentajeSubsidio" />
                  <label class="label-radio" for="porcentaje1">50%</label>
                </div>
              </div>
              <!-- Columna 3 -->
              <div class="col-12 col-md-4">
                <div class="group-radio">
                  <input class="radio-input" type="radio" value="2" id="porcentaje2" name="porcentajeSubsidio"
                    formControlName="porcentajeSubsidio" />
                  <label class="label-radio" for="porcentaje2">100%</label>
                </div>
              </div>
            </div>
            <div class="row p-0 m-0 mt-3 align-items-center">
              <div class="col-6">
                <h3><strong>DATOS DE CONTACTO</strong></h3>
              </div>
              <div class="col-6 text-end">
                Datos del contacto igual a quien se dirige
                <mat-slide-toggle formControlName="igualAQuienSeDirige" />
              </div>
            </div>

            <div class="row p-0 m-0 mt-3">
              <div class="col-xs-12 col-md-3 col-lg-3">
                <mat-label>Nombre</mat-label>
                <mat-form-field class="example-full-width" appearance="outline">
                  <input matInput formControlName="NombreContacto" maxlength="40"
                    (input)="normalizarTextoContacto('NombreContacto')">
                  <mat-error *ngIf="formColectivo.get('NombreContacto')?.hasError('required')">El nombre es obligatorio.</mat-error>
                  <mat-error *ngIf="formColectivo.get('NombreContacto')?.hasError('maxlength')">Máximo 40 caracteres.</mat-error>
                </mat-form-field>
              </div>

              <div class="col-xs-12 col-md-3 col-lg-3">
                <mat-label>Cargo</mat-label>
                <mat-form-field class="example-full-width" appearance="outline">
                  <input matInput formControlName="cargoContacto" maxlength="40"
                    (input)="normalizarTextoContacto('cargoContacto')">
                  <mat-error *ngIf="formColectivo.get('cargoContacto')?.hasError('required')">El cargo es obligatorio.</mat-error>
                  <mat-error *ngIf="formColectivo.get('cargoContacto')?.hasError('maxlength')">Máximo 40 caracteres.</mat-error>
                </mat-form-field>
              </div>

              <div class="col-xs-12 col-md-3 col-lg-3">
                <mat-label>Email</mat-label>

                <mat-form-field class="example-full-width" appearance="outline">
                  <input matInput type="email" formControlName="emailContacto"
                    (input)="bloquearEspaciosEmail('emailContacto')">
                  <mat-error *ngIf="formColectivo.get('emailContacto')?.hasError('required')">El correo es obligatorio.</mat-error>
                  <mat-error *ngIf="formColectivo.get('emailContacto')?.hasError('email') || formColectivo.get('emailContacto')?.hasError('pattern')">Ingrese un correo válido.</mat-error>
                </mat-form-field>
              </div>

              <div class="col-xs-12 col-md-3 col-lg-3">
                <mat-label>Teléfono</mat-label>
                <mat-form-field class="example-full-width" appearance="outline">
                  <input matInput type="text" inputmode="numeric" pattern="[0-9]*" formControlName="telefonoContacto"
                    maxlength="15" (keypress)="permitirSoloNumeros($event)"
                    (paste)="validarPegadoSoloNumeros($event)"
                    (input)="normalizarTelefonoColectivo('telefonoContacto')">
                  <mat-error *ngIf="formColectivo.get('telefonoContacto')?.hasError('required')">El teléfono es obligatorio.</mat-error>
                  <mat-error *ngIf="formColectivo.get('telefonoContacto')?.hasError('pattern')">Solo se permiten números.</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row p-0 m-0 mt-3">
              <div class="col-12">
                <h3><strong>DATOS DEL DESTINATARIO</strong></h3>
              </div>
              <div class="col-xs-12 col-md-3 col-lg-3">
                <mat-label>Nombre</mat-label>
                <mat-form-field class="example-full-width" appearance="outline">
                  <input matInput formControlName="NombreDestinatario" maxlength="40"
                    (input)="normalizarTextoContacto('NombreDestinatario')">
                  <mat-error *ngIf="formColectivo.get('NombreDestinatario')?.hasError('required')">El nombre es obligatorio.</mat-error>
                  <mat-error *ngIf="formColectivo.get('NombreDestinatario')?.hasError('maxlength')">Máximo 40 caracteres.</mat-error>
                </mat-form-field>
              </div>

              <div class="col-xs-12 col-md-3 col-lg-3">
                <mat-label>Cargo</mat-label>
                <mat-form-field class="example-full-width" appearance="outline">
                  <input matInput formControlName="cargoDestinatario" maxlength="40"
                    (input)="normalizarTextoContacto('cargoDestinatario')">
                  <mat-error *ngIf="formColectivo.get('cargoDestinatario')?.hasError('required')">El cargo es obligatorio.</mat-error>
                  <mat-error *ngIf="formColectivo.get('cargoDestinatario')?.hasError('maxlength')">Máximo 40 caracteres.</mat-error>
                </mat-form-field>
              </div>

              <div class="col-xs-12 col-md-3 col-lg-3">
                <mat-label>Email</mat-label>
                <mat-form-field class="example-full-width" appearance="outline">
                  <input matInput type="email" formControlName="emailDestinatario"
                    (input)="bloquearEspaciosEmail('emailDestinatario')">
                  <mat-error *ngIf="formColectivo.get('emailDestinatario')?.hasError('required')">El correo es obligatorio.</mat-error>
                  <mat-error *ngIf="formColectivo.get('emailDestinatario')?.hasError('email') || formColectivo.get('emailDestinatario')?.hasError('pattern')">Ingrese un correo válido.</mat-error>
                </mat-form-field>
              </div>

              <div class="col-xs-12 col-md-3 col-lg-3">
                <mat-label>Teléfono</mat-label>
                <mat-form-field class="example-full-width" appearance="outline">
                  <input matInput type="text" inputmode="numeric" pattern="[0-9]*" formControlName="telefonoDestinatario"
                    maxlength="15" (keypress)="permitirSoloNumeros($event)"
                    (paste)="validarPegadoSoloNumeros($event)"
                    (input)="normalizarTelefonoColectivo('telefonoDestinatario')">
                  <mat-error *ngIf="formColectivo.get('telefonoDestinatario')?.hasError('required')">El teléfono es obligatorio.</mat-error>
                  <mat-error *ngIf="formColectivo.get('telefonoDestinatario')?.hasError('pattern')">Solo se permiten números.</mat-error>
                </mat-form-field>
              </div>

            </div>
            <div class="row p-0 m-0 mt-3">
              <div class="col-12 text-center">
                <button type="button" (click)="guardarInformacionColectivo()" class="btn btn-primary btn-guardar-pill"
                  [disabled]="isEditMode && !esVersionMasReciente">
                  GUARDAR
                </button>
              </div>
            </div>
          </form>
        </mat-tab>
        <mat-tab *ngIf="tabHabilitado.beneficiarios" label="BENEFICIARIOS">
          <div class="benef-header">
            <div class="benef-search-group">
              <input matInput type="search" placeholder="Buscador general" (ngModelChange)="onTextChange($event)"
                [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}" (keyup.enter)="filterByText()"
                class="benef-input" />
              <button color="primary" class="btn-icon">
                <mat-icon matSuffix class="material-icons" (click)="filterByText()">search</mat-icon>
              </button>
              <button mat-raised-button color="primary" (click)="limpiar()" class="btn-clean"
                matTooltipClass="custom-tooltip">
                LIMPIAR
              </button>
            </div>
          </div>
          <div class="benef-action-row">
            <div class="benef-action-group">
              <button *ngIf="selectedIndex === 2 && !(isEditMode && !esVersionMasReciente)"
                (click)="openDialogBeneficiary()" mat-raised-button color="primary" class="btn-create"
                matTooltipClass="custom-tooltip">
                <mat-icon class="material-icons">add</mat-icon>
                CREAR BENEFICIARIO
              </button>
            </div>
          </div>
          <div class="table-responsive">
            <table mat-table [dataSource]="datasSourceBeneficiary">
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> NOMBRE </th>
                <td mat-cell align="center" *matCellDef="let element">
                  <label style="align-items: center;">
                    {{ element.primer_nombre || element.name }}
                    {{ element.segundo_nombre || element.secondname }}
                    <br>
                    {{ element.primer_apellido || element.lastname }}
                    {{ element.segundo_apellido || element.secondsurname }}
                  </label>
                </td>
              </ng-container>
              <ng-container matColumnDef="documentnumber">
                <th mat-header-cell *matHeaderCellDef> NO. DOCUMENTO </th>
                <td mat-cell align="center" *matCellDef="let element">
                  <label>
                    {{element.num_documento}}
                  </label>
                </td>
              </ng-container>
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef> PARENTESCO </th>
                <td mat-cell align="center" *matCellDef="let element">
                  <label>
                    {{(element.parentesco_id === "T") ? "Titular" : element.typeDescripcion}}
                  </label>
                </td>
              </ng-container>
              <ng-container matColumnDef="lineofbusiness">
                <th mat-header-cell *matHeaderCellDef> LINEA DE NEGOCIO </th>
                <td mat-cell align="center" *matCellDef="let element">
                  <label>
                    {{ formatLineOfBusinessLabel(element.lineOfBusiness) }}
                  </label>
                </td>
              </ng-container>
              <ng-container matColumnDef="program">
                <th mat-header-cell *matHeaderCellDef> PROGRAMA </th>
                <td mat-cell align="center" *matCellDef="let element">
                  <label>
                    {{element.program}}
                  </label>
                </td>
              </ng-container>
              <ng-container matColumnDef="opcion">
                <th mat-header-cell *matHeaderCellDef> ACCIONES </th>
                <td align="right" mat-cell *matCellDef="let element">
                  <ng-container *ngIf="!(isEditMode && !esVersionMasReciente); else soloLecturaIconos">
                    <mat-icon class="mat-icon-action" matTooltip="Editar" (click)="editarBeneficiario(element)"
                      color="primary">edit_square</mat-icon>
                    <mat-icon class="mat-icon-action" matTooltip="Eliminar" (click)="removeListBeneficity(element)"
                      color="warn">remove_circle_outlin</mat-icon>
                  </ng-container>
                  <ng-template #soloLecturaIconos>
                    <mat-icon class="mat-icon-action" color="primary"
                      style="opacity: 0.35; cursor: default;">visibility</mat-icon>
                  </ng-template>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              <tr class="no-data-row" *matNoDataRow>
                <td class="no-data-message" [attr.colspan]="displayedColumns.length">
                  AÚN NO HAY INFORMACIÓN PARA MOSTRAR
                </td>
              </tr>
            </table>
            <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons
              aria-label="Select page of periodic elements">
            </mat-paginator>
          </div>

        </mat-tab>
        <mat-tab *ngIf="mostrarTabCotizacionSoloColectivo" label="COTIZACIÓN">
          <div *ngIf="mostrarResumenCotizacionColectivo" class="cotizacion-colectivo-view">
            <section class="cotizacion-colectivo-header">
              <h2 class="cotizacion-colectivo-title">RESUMEN DE LA COTIZACIÓN</h2>
            </section>
            <div class="cotizacion-colectivo-topbar">
              <div class="cotizacion-colectivo-toggle-row">
                <span>Mostrar todos los escenarios de subsidio:</span>
                <label class="colectivo-switch">
                  <input type="checkbox" [checked]="mostrarTodosEscenariosSubsidio"
                    (change)="mostrarTodosEscenariosSubsidio = $any($event.target).checked; paginaResumenColectivoActual = 0">
                  <span class="colectivo-switch-slider"></span>
                </label>
              </div>
              <div class="cotizacion-colectivo-actions">
                <input type="search" class="cotizacion-colectivo-search" placeholder="Buscador general"
                  [(ngModel)]="busquedaResumenColectivoInput" [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="onBusquedaResumenColectivoInputChange($event)"
                  (keypress)="onBusquedaResumenColectivoKeyPress($event)"
                  (keyup.enter)="onBusquedaResumenColectivoChange(busquedaResumenColectivoInput)">
                <button type="button" class="cotizacion-colectivo-icon-btn" aria-label="Buscar" title="Buscar"
                  (click)="onBusquedaResumenColectivoChange(busquedaResumenColectivoInput)">
                  <mat-icon>search</mat-icon>
                </button>
                <button type="button" class="cotizacion-colectivo-clear-btn"
                  (click)="limpiarResumenCotizacionColectivo()" title="Limpiar búsqueda">
                  LIMPIAR
                </button>
              </div>
            </div>
            <p class="cotizacion-colectivo-note"><strong>Nota:</strong> Todos los valores mostrados incluyen IVA.</p>
            <div class="cotizacion-colectivo-table-wrap">
              <table class="cotizacion-colectivo-table">
                <thead>
                  <tr>
                    <th>PROGRAMA</th>
                    <th class="rango-edad-cell">RANGO DE EDAD</th>
                    <th *ngIf="mostrarColumnaTarifaSinSubsidioResumen">TARIFA SIN SUBSIDIO POR EMPRESA CONTRATANTE</th>
                    <th *ngIf="mostrarColumnaTarifaSubsidio50Resumen">TARIFA 50% SUBSIDIO POR EMPRESA CONTRATANTE</th>
                    <th *ngIf="mostrarColumnaTarifaSubsidio100Resumen">TARIFA 100% SUBSIDIO POR EMPRESA CONTRATANTE</th>
                    <th *ngIf="mostrarColumnaTarifaAnexoResumen">TARIFA DE ANEXO</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of resumenCotizacionColectivoPaginado">
                    <td>{{ item.programa }}</td>
                    <td class="rango-edad-cell">{{ item.rangoEdad }}</td>
                    <td *ngIf="mostrarColumnaTarifaSinSubsidioResumen" class="currency-cell">$ {{
                      valorMoneda(item.tarifaSinSubsidio) }}</td>
                    <td *ngIf="mostrarColumnaTarifaSubsidio50Resumen" class="currency-cell">$ {{
                      valorMoneda(item.tarifaSubsidio50) }}</td>
                    <td *ngIf="mostrarColumnaTarifaSubsidio100Resumen" class="currency-cell">$ {{
                      valorMoneda(item.tarifaSubsidio100) }}</td>
                    <td *ngIf="mostrarColumnaTarifaAnexoResumen" class="currency-cell">
                      <ng-container *ngIf="item.aplicaAnexoServicio; else sinAnexoEnFila">$ {{
                        valorMoneda(item.tarifaAnexo || 0) }}</ng-container>
                      <ng-template #sinAnexoEnFila>-</ng-template>
                    </td>
                  </tr>
                  <tr *ngIf="totalRegistrosResumenColectivo === 0">
                    <td [attr.colspan]="totalColumnasTablaResumenColectivo" class="cotizacion-colectivo-empty">No
                      hay
                      resultados para mostrar.</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="cotizacion-colectivo-footer">
              <div class="cotizacion-colectivo-pagination">
                <span>Registros por paginas</span>
                <select class="cotizacion-colectivo-page-size" [ngModel]="registrosPorPaginaResumenColectivo"
                  [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="onRegistrosPorPaginaResumenColectivoChange($event)">
                  <option [ngValue]="10">10</option>
                  <option [ngValue]="25">25</option>
                  <option [ngValue]="50">50</option>
                  <option [ngValue]="100">100</option>
                </select>
                <span>{{ paginaActualResumenColectivoVisual }} of {{ totalPaginasResumenColectivoVisual }}</span>
                <div class="cotizacion-colectivo-page-buttons">
                  <button type="button" (click)="irAPrimeraPaginaResumenColectivo()"
                    [disabled]="paginaResumenColectivoActual === 0">
                    <mat-icon>first_page</mat-icon>
                  </button>
                  <button type="button" (click)="irAPaginaAnteriorResumenColectivo()"
                    [disabled]="paginaResumenColectivoActual === 0">
                    <mat-icon>chevron_left</mat-icon>
                  </button>
                  <button type="button" (click)="irAPaginaSiguienteResumenColectivo()"
                    [disabled]="paginaResumenColectivoActual >= totalPaginasResumenColectivo - 1">
                    <mat-icon>chevron_right</mat-icon>
                  </button>
                  <button type="button" (click)="irAUltimaPaginaResumenColectivo()"
                    [disabled]="paginaResumenColectivoActual >= totalPaginasResumenColectivo - 1">
                    <mat-icon>last_page</mat-icon>
                  </button>
                </div>
              </div>
              <div class="cotizacion-colectivo-save">
                <button type="button" class="btn btn-primary btn-guardar-pill"
                  [disabled]="botonesCotizacionColectivoDeshabilitados || (isEditMode && !esVersionMasReciente)"
                  (click)="guardarResumenCotizacionColectivo()">GUARDAR</button>
                <button type="button" class="btn btn-primary btn-guardar-pill btn-descargar-cotizacion"
                  [disabled]="botonDescargarCotizacionColectivoDeshabilitado || (isEditMode && !esVersionMasReciente)"
                  (click)="descargarPDFDesdeDatos()">DESCARGAR COTIZACIÓN</button>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab *ngIf="mostrarTabCotizacionBeneficiarios" label="COTIZACIÓN">
          <app-cotizador-cotizacion #cotizadorCotizacion [idCotizacion]="isEditMode ? idCotizacionEdicion : null"
            [isLatestVersion]="isEditMode && !esNuevoColectivo ? esVersionMasReciente : true"
            [cotizacionData]="isEditMode && !esNuevoColectivo ? cotizacionEdicionData : null"
            [cotizacionModificadaExternamente]="cotizacionIndividualModificada"
            [deshabilitadoPorVersionHistorica]="isEditMode && !esVersionMasReciente"
            (bloqueoNavegacionChange)="onBloqueoNavegacionCotizacion($event)"
            (cargaInicialChange)="onCargaInicialCotizacionChange($event)"
            (versionCreadaEvent)="onVersionCreadaCotizacion($event)"></app-cotizador-cotizacion>

          <!-- <div *ngIf="this.formInit.get('tipoCotizacion')?.value == 'm' && !mostrarResumen"
            style="margin-left: 20px;margin-right: 20px;">
            <br>
            <div class="row">
              <h2 class="color-main"> <strong>COMPARATIVO</strong> </h2>
            </div>
            <div class="row">
              <table>
                <tr>
                  <td style="text-align: center;" *ngIf="ocultarPlanFamiliar">

                    <h5 class="color-main">
                      <img src="assets/imagenes/peso.png"> CUOTA MENSUAL TOTAL FAMILIAR
                    </h5>
                    <label>${{this.valorMoneda(valorFamiliaTotal)}}</label>

                  </td>
                  <td style="text-align: center;" class="border-left">

                    <h5 class="color-main"> <img src="assets/imagenes/peso.png">
                      CUOTA MENSUAL TOTAL ASOCIADO
                    </h5>
                    <label>${{this.valorMoneda(valorAsociadoTotal)}}</label>

                  </td>
                  <td style="text-align: center;" class="border-left">

                    <h5 class="color-main"><img src="assets/imagenes/peso.png">
                      CUOTA DE INSCRIPCIÓN
                    </h5>
                    <label>${{this.valorMoneda(valCuota)}}</label>
                  </td>
                  <td style="text-align: center;" class="border-left">
                    <h5 (click)="!(isEditMode && !esVersionMasReciente) && multAddClient()" class="color-main"
                      [style.opacity]="(isEditMode && !esVersionMasReciente) ? '0.4' : '1'"
                      [style.cursor]="(isEditMode && !esVersionMasReciente) ? 'not-allowed' : 'pointer'">
                      <img src="assets/imagenes/add.png">
                      AÑADIR BENEFICIARIO
                    </h5>
                  </td>
                </tr>
              </table>
            </div>
            <br>
            <div class="row">
              <div class="table-responsive" *ngFor="let item of listLineaTable; let i = index;">
                <table class="table table-striped"
                  [ngClass]="{'sticky-header-table': item.listBeneficiario.length > 3}">
                  <thead style="background-color: #0372b9">
                    <th colspan="20">
                      <table>
                        <tr>
                          <td style="width: 50%;">
                            <label style="color: white;"> {{item.nombre}} </label>
                          </td>
                          <td>
                            <label style="color: white;"> </label>
                          </td>
                          <td>
                            <label style="color: white;"> </label>
                          </td>
                        </tr>
                      </table>
                    </th>
                  </thead>

                  <tbody style="background:#f1f0f0;">
                    <tr>
                      <td></td>
                      <td *ngFor="let beneficiario of item.listBeneficiario; let i = index" style="text-align: center;">
                        <div class="col-md-8 multiproducto-tarifa-select">
                          <mat-label>Tarifa *</mat-label>
                          <mat-form-field *ngIf="tipoSolicitud === '1'" color="primary" appearance="outline">
                            <mat-select
                              (selectionChange)="actualizarTarifas($event.value, beneficiario.beneficiario, i, item.key)"
                              [(ngModel)]="selectedValue[i + '-' + subStrCuenta(item.key)]" name="tarifa" required
                              [disabled]="isEditMode && !esVersionMasReciente">
                              <mat-option>Seleccionar</mat-option>
                              <mat-option *ngFor="let tarifa of beneficiario.list_tarifa[subStrCuenta(item.key)]"
                                [value]="tarifa.tarifa">
                                {{tarifa.tarifa}} - {{tarifa.descripcion}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td *ngFor="let beneficiario of item.listBeneficiario" style="text-align: center;">
                        <label> {{beneficiario.beneficiario}} </label>
                      </td>
                    </tr>
                    <tr *ngFor="let b of item.itemsPago">
                      <td style="text-align: center;">
                        <img width="75px" src="{{b.programa.file}}">
                      </td>
                      <td *ngFor="let c of b.data; let idxB = index">
                        <div (click)="!(isEditMode && !esVersionMasReciente) && seleccionarMultiProducto(c, item, idxB)"
                          class="card btn" [style.opacity]="(isEditMode && !esVersionMasReciente) ? '0.6' : '1'"
                          [style.cursor]="(isEditMode && !esVersionMasReciente) ? 'not-allowed' : 'pointer'">
                          <div style="background-color: white;border-bottom: none;" class="card-header">
                            <label *ngIf="c.estado" class="checkProducto">
                              <span style="text-align: center;">&#10003;</span>
                            </label>
                          </div>
                          <div class="card-body">
                            <label *ngIf="ocultarPlanFamiliar" class="color-main"><strong>Familiar:</strong>
                              ${{this.valorMoneda(c.valor1)}}</label>
                            <br>
                            <label class="color-main"><strong>Asociado: </strong> ${{(dataCampania.codigo_tipo_plan !==
                              'F') ? this.valorMoneda(c.valor1) : this.valorMoneda(c.valor2)}}</label>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>

                </table>
              </div>
            </div>
            <div class="row">
              <div style="text-align: end;" class="col-md-4 offset-md-8">
                <button type="button" (click)="continuarMultiple()"
                  style="margin-left: 0px;margin-top: 10px;margin-bottom: 20px;background-color: #0372b9;"
                  class="btn btn-primary">
                  Continuar
                </button>
              </div>
            </div>
          </div> -->
          <div
            *ngIf="this.formInit.get('tipoCotizacion')?.value === 'm' && mostrarResumen && !mostrarResumenCotizacionProgramaVisual">
            <app-cotizacion-multiple [numeroCotizacion]="numeroCotizacion" [formInit]="formInit"
              [detalle_descuentos]="detalle_descuentos" [listLineaTable]="listLineaTableMulti"
              [listDataCampania]="listDataCampania" [dataCampania]="dataCampania">
            </app-cotizacion-multiple>
            <div class="row m-0">
              <div style="text-align: end;" class="col-md-4 offset-md-8">
                <button type="button" (click)="guardar()"
                  style="margin-right: 20px; margin-top: 10px; margin-bottom: 20px;" class="btn btn-light"
                  [disabled]="isEditMode && !esVersionMasReciente" data-convo-id="btn3" #el>Guardar</button>

                <button type="button" *ngIf="formInit.get('tipoCotizacion')?.value == 'm'"
                  (click)="comeBackBeneficiary()" style="margin-right: 20px;margin-top: 10px;margin-bottom: 20px;"
                  class="btn btn-light">Atras</button>

                <button type="button" (click)="guardarEnviar()" appTrackClick [trackData]="trackDataCarnet"
                  style="margin-left: 0px;margin-top: 10px;margin-bottom: 20px;background-color: #0372b9;"
                  [disabled]="isEditMode && !esVersionMasReciente" class="btn btn-primary">Guardar y
                  Enviar</button>

                <button type="submit" onclick="location.reload()"
                  style="margin-left: 20px;margin-top: 10px;margin-bottom: 20px;"
                  class="btn btn-light">Cancelar</button>

              </div>
            </div>
          </div>
          <div
            *ngIf="(this.formInit.get('tipoCotizacion')?.value === 'u' || mostrarResumen) && this.formInit.get('tipoCotizacion')?.value !== 'm' && !mostrarResumenCotizacionProgramaVisual">
            <br>
            <h2 class="row color-main" style="padding-bottom: 16px;"> <strong> NÚMERO DE COTIZACIÓN:
                #{{numeroCotizacion}} </strong> </h2>
            <br>
            <div class="row">
              <div class="col-md-6">
                <table>
                  <tr>
                    <td style="text-align: center;">
                      <h3 class="color-main"> {{lineaNombre}}</h3>
                      <label>Tipo de línea</label>
                    </td>
                    <td style="text-align: center;" class="border-left">
                      <h3 class="color-main"> {{planNombre}}</h3>
                      <label>Tipo de plan</label>
                    </td>
                    <td style="text-align: center;" class="border-left">
                      <h3 class="color-main"><img src="assets/imagenes/peso.png">
                        ${{this.valorMoneda(cuotaInscripcion)}}
                      </h3>
                      <label>Cuota de inscripción</label>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="col-md-6">
                <table>
                  <tr>
                    <td style="text-align: center;" class="border-left">
                      <h3 class="color-main"><img src="assets/imagenes/peso.png"> ${{this.valorMoneda(cuotaTotal)}}</h3>
                      <label>Cuota mensual total</label>
                    </td>
                    <td style="text-align: center;" class="border-left">
                      <img width="75px" src="{{imgPrograma}}">
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <br>
            <h1 class="row color-main">
              Detalle pago mensual
            </h1>
            <div class="row">
              <div class="col-md-12">
                <table class="table table-striped">
                  <tbody>
                    <tr *ngFor="let item of listDetallePagoMensual">
                      <td>
                        <label>
                          {{item.beneficiario}}
                        </label>
                      </td>
                      <td class="color-main" *ngIf="ocultarPlanFamiliar && dataCampania.codigo_tipo_plan === 'F'">
                        <label>
                          <strong>FAMILIAR: ${{ this.valorMoneda( item.valor1) }} </strong>
                        </label>
                      </td>
                      <td class="color-main" *ngIf="ocultarPlanAsociado">
                        <label>
                          <strong>ASOCIADO: ${{ this.valorMoneda( dataCampania.codigo_tipo_plan === 'F' ? item.valor2 :
                            item.valor1) }} </strong>
                        </label>
                      </td>
                      <td *ngIf="this.formInit.get('tipoCotizacion')?.value == 'm'">
                        <img (click)="eliminarItem(item)" src="assets/imagenes/delete.png">
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <br>
            <h1 class="row color-main">
              Valor pago anticipado
            </h1>
            <div class="row">

              <div class="col-md-4">

                <table style="border-radius:20px" class="jumbotron">
                  <tr>
                    <td style="height: 30px;"></td>
                  </tr>
                  <tr>
                    <td style="text-align: center;">
                      <h3 class="color-main"><strong>Meses</strong></h3>
                    </td>
                  </tr>
                  <tr>
                    <td style="color: transparent;">.</td>
                  </tr>
                  <tr>
                    <td style="text-align: center;">
                      <label>
                        <strong>3 meses</strong>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: center;">
                      <label>
                        <strong>6 meses</strong>
                      </label>

                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: center;">
                      <label>
                        <strong>12 meses</strong>
                      </label>

                    </td>
                  </tr>
                  <tr>
                    <td style="height: 30px;"></td>
                  </tr>
                </table>

              </div>
              <div class="col-md-4">

                <table style="border-radius:20px" class="jumbotron">
                  <tr>
                    <td style="height: 30px;"></td>
                  </tr>
                  <tr>
                    <td colspan="2" style="text-align: center;">
                      <h3 class="color-main"><strong>Valor descuento pago anticipado</strong></h3>
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: center;" *ngIf="ocultarPlanFamiliar">
                      <label>
                        <strong>Familiar</strong>
                      </label>

                    </td>
                    <td style="text-align: center;" *ngIf="ocultarPlanAsociado">
                      <label>
                        <strong>Asociado</strong>
                      </label>

                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: center;" *ngIf="ocultarPlanFamiliar">
                      <label>
                        ${{this.valorMoneda(detalle_descuentos[0].valor_descuento_familiar)}}
                      </label>
                    </td>
                    <td class="border-left" style="text-align: center;" *ngIf="ocultarPlanAsociado">
                      <label>
                        ${{this.valorMoneda(detalle_descuentos[0].valor_descuento_asociado)}}
                      </label>

                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: center;" *ngIf="ocultarPlanFamiliar">
                      <label>
                        ${{this.valorMoneda(detalle_descuentos[1].valor_descuento_familiar)}}
                      </label>

                    </td>
                    <td class="border-left" style="text-align: center;" *ngIf="ocultarPlanAsociado">
                      <label>
                        ${{this.valorMoneda(detalle_descuentos[1].valor_descuento_asociado)}}
                      </label>

                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: center;" *ngIf="ocultarPlanFamiliar">
                      <label>
                        ${{this.valorMoneda(detalle_descuentos[2].valor_descuento_familiar)}}
                      </label>

                    </td>
                    <td class="border-left" style="text-align: center;" *ngIf="ocultarPlanAsociado">
                      <label>
                        ${{this.valorMoneda(detalle_descuentos[2].valor_descuento_asociado)}}
                      </label>

                    </td>
                  </tr>
                  <tr>
                    <td style="height: 30px;"></td>
                  </tr>
                </table>

              </div>
              <div class="col-md-4">

                <table style="background-color: #0372b9;border-radius:20px" class="jumbotron">
                  <tr>
                    <td style="height: 30px;"></td>
                  </tr>
                  <tr>
                    <td colspan="2" style="text-align: center">
                      <h3 style="color: white !important;" class="color-main">
                        <strong>
                          Valor a pagar anticipado
                        </strong>
                      </h3>
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: center;color: white;" *ngIf="ocultarPlanFamiliar">
                      <label>
                        <strong>Familiar</strong>
                      </label>
                    </td>
                    <td style="text-align: center;color: white;" *ngIf="ocultarPlanAsociado">
                      <label>
                        <strong>Asociado</strong>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: center;color: white;" *ngIf="ocultarPlanFamiliar">
                      <label>
                        ${{this.valorMoneda(detalle_descuentos[0].valor_pago_anticipado_familiar)}}
                      </label>


                    </td>
                    <td class="border-left" style="text-align: center;color: white;" *ngIf="ocultarPlanAsociado">
                      <label>
                        ${{this.valorMoneda(detalle_descuentos[0].valor_pago_anticipado_asociado)}}
                      </label>

                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: center;color: white;" *ngIf="ocultarPlanFamiliar">
                      <label>
                        ${{this.valorMoneda(detalle_descuentos[1].valor_pago_anticipado_familiar)}}
                      </label>

                    </td>
                    <td class="border-left" style="text-align: center;color: white;" *ngIf="ocultarPlanAsociado">
                      <label>
                        ${{this.valorMoneda(detalle_descuentos[1].valor_pago_anticipado_asociado)}}
                      </label>

                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: center;color: white;" *ngIf="ocultarPlanFamiliar!">
                      <label>
                        ${{this.valorMoneda(detalle_descuentos[2].valor_pago_anticipado_familiar)}}
                      </label>

                    </td>
                    <td class="border-left" style="text-align: center;color: white;" *ngIf="ocultarPlanAsociado">
                      <label>
                        ${{this.valorMoneda(detalle_descuentos[2].valor_pago_anticipado_asociado)}}
                      </label>

                    </td>
                  </tr>
                  <tr>
                    <td style="height: 30px;"></td>
                  </tr>
                </table>

              </div>
            </div>
            <div class="row m-0">
              <div style="text-align: end;" class="col-md-4 offset-md-8">
                <button type="button" (click)="guardar()" style="margin-top: 10px; margin-bottom: 20px;"
                  class="btn btn-light" data-convo-id="btn3" [disabled]="isEditMode && !esVersionMasReciente" #el>
                  Guardar
                </button>

                <button type="button" *ngIf="formInit.get('tipoCotizacion')?.value == 'm'"
                  (click)="comeBackBeneficiary()" style="margin-right: 20px;margin-top: 10px;margin-bottom: 20px;"
                  class="btn btn-light">Atras</button>

                <button type="button" (click)="guardarEnviar()"
                  style="margin-left: 0px;margin-top: 10px;margin-bottom: 20px;background-color: #0372b9;"
                  [disabled]="isEditMode && !esVersionMasReciente" class="btn btn-primary">Guardar y
                  Enviar</button>

                <button type="submit" onclick="location.reload()"
                  style="margin-left: 20px;margin-top: 10px;margin-bottom: 20px;"
                  class="btn btn-light">Cancelar</button>

              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>

    <!-- BOTON INICIO -->
    <button [hidden]="selectedIndex !== 0" type="button" (click)="tabOption(null, 1)" mat-fab color="primary"
      [disabled]="botonContinuarInicioDeshabilitado" class="btn-continuar-fab"
      style="position: fixed; right: 3%; bottom: 12%; z-index: 1;" matTooltip="Continuar"
      matTooltipClass="custom-tooltip" id="btn1">
      <mat-icon style="color: #FFFFFF;">arrow_forward</mat-icon>
    </button>
    <!-- BOTON CONTRATANTE -->
    <button [hidden]="selectedIndex !== 1" (click)="tabOption(null, 2)" mat-fab color="primary"
      [disabled]="botonContinuarPaso2Deshabilitado" class="btn-continuar-fab"
      style="position: fixed; right: 3%; bottom: 12%; z-index: 1;" matTooltip="Continuar"
      matTooltipClass="custom-tooltip">
      <mat-icon style="color: #FFFFFF;">arrow_forward</mat-icon>
    </button>
    <!-- BOTON BENEFICIARIO -->
    <button [hidden]="selectedIndex !== 2 || esNuevoColectivo" (click)="onContinuarBeneficiarios()" mat-fab
      color="primary" [disabled]="botonContinuarPaso3Deshabilitado" class="btn-continuar-fab"
      style="position: fixed; right: 3%; bottom: 12%; z-index: 1;" matTooltip="Continuar"
      matTooltipClass="custom-tooltip">
      <mat-icon style="color: #FFFFFF;">arrow_forward</mat-icon>
    </button>
  </div>
</div>
